import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./SignIn.scss";
import axios from "axios";
import { toast } from "react-toastify";
import loginBg from "../../assets/images/logo/Group 1.png";

const SignIn = () => {
  const [userType, setUserType] = useState(null);
  const [userValue, setUserValue] = useState(null);
  const [userToogle, setUserToogle] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const loginFunction = async (e) => {
    e.preventDefault();

    // Prevent multiple submissions
    if (isLoading) return;
    setIsLoading(true);

    // Notification functions
    const notify = {
      invalidCredential: () => toast.info("Invalid Credential"),
      pauseStudent: () =>
        toast.warning("Hi! Your account is currently on pause"),
      schoolSelect: () => toast.error("Please Select School"),
      allFields: () =>
        toast.error("All Fields Are Mandatory", { autoClose: 1000 }),
      error: (msg) => toast.error(msg),
      success: () => toast.success("Login successful"),
    };

    try {
      // Validate inputs
      // if (!localStorage.getItem("session_school_id")) {
      //   notify.schoolSelect();
      //   navigate("/");
      //   return;
      // }

      if (email === "" || password === "" || !userType) {
        notify.allFields();
        return;
      }
      // Prepare form data
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);
      formData.append("action_type", userType);
      formData.append("school", 2);
      formData.append("status", "active");

      // Make API call
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/?login_cookie=null&login_user_id=null&login_action_type=null&f=login&status=1`,
        formData
      );

      // Handle response
      if (response.data.status === false) {
        if (response.data.message === 406) {
          notify.invalidCredential();
          setEmail("");
          setPassword("");
          return;
        } else if (response.data.message === 100) {
          notify.error(response.data.error_message);
        } else if (response.data.message!==null && response.data.message!==undefined) {
          notify.error(response.data.message);
        }
        return;
      }

      if (Number(response.data.is_pause_student) === 1) {
        notify.pauseStudent();
      }

      // Store session data
      storeSessionData(response.data);

      // Navigate to dashboard
      navigate(Number(response.data.is_pause_student) === 1 ? "/Home/course/pauseCourse" : "/Home/dashboard");
      notify.success();
    } catch (error) {
      console.error("Login error:", error);
      notify.error("An error occurred during login");
    } finally {
      setIsLoading(false);
    }
  };

  // Helper function to store session data
  const storeSessionData = (data) => {
    const sessionData = {
      session_school_login_type: userType,
      session_school_id: data.school_id,
      session_user_api_id: data.user_api_id,
      session_user_package_duration: data.user_package_duration,
      session_school_type: data.student_school_type,
      session_user_package_id: data.user_package_id,
      session_user_package_activated_date: data.user_package_activated_date,
      session_user_profile_pic_status: data.user_profile_pic_status,
      session_user_school_parent_id: data.user_school_parent_id,
      is_pause_student: data.is_pause_student,
      session_user_device_id: data.user_device_id,
      session_user_level_id: data.user_level_id,
      session_admin_name: data.admin_name,
      session_user_updated_date: data.user_updated_date,
      session_user_country: data.user_country,
      session_setting_show_pic_inside_group: data.setting_show_pic_inside_group,
      session_user_lastname: data.user_lastname,
      session_user_login_cookie: data.login_cookie,
      session_user_package_description: data.user_package_description,
      session_user_renewal_notify: data.user_renewal_notify,
      session_user_selected_type: data.user_selected_type,
      session_user_status: data.user_status,
      session_admin_email: data.admin_email,
      session_setting_newsletter: data.setting_newsletter,
      session_user_contact: data.user_contact,
      session_user_password: data.user_password,
      session_user_address: data.user_address,
      session_user_package_expired_date: data.user_package_expired_date,
      session_user_is_ceo: data.is_ceo,
      session_user_school_email: data.user_school_email,
      session_user_state: data.user_state,
      session_setting_show_online_friends: data.setting_show_online_friends,
      session_user_sender_id: data.user_sender_id,
      session_user_city: data.user_city,
      session_user_id: data.user_id,
      session_user_email: data.user_email,
      session_user_profile_pic: data.user_profile_pic,
      session_school_image: data.school_image,
      session_student_teacher: data.teacher_id_student,
      session_user_created_date: data.user_created_date,
      session_premium_status_page: data.premium_status_page,
      session_setting_event: data.setting_event,
      session_admin_id: data.admin_id,
      session_setting_account: data.setting_account,
      session_user_package_cost: data.user_package_cost,
      session_user_gender: data.user_gender,
      session_user_school_name: data.user_school_name,
      teacher_id_student: data.teacher_id_student,
      session_user_type: data.user_type,
      session_setting_notification: data.setting_notification,
      session_language: "en",
      session_user_zipcode: data.user_zipcode,
      session_user_phonenumber: data.user_phonenumber,
      is_external_teacher: data.is_external_teacher,
      review: 1,
      session_user_firstname: data.user_firstname,
      session_user_login_time: data.login_time,
      session_deChatPlaceholder: data.deChatPlaceholder,
      session_deEmptyChatMessage: data.deEmptyChatMessage,
      session_deMainLabel: data.deMainLabel,
      session_enChatPlaceholder: data.enChatPlaceholder,
      session_enEmptyChatMessage: data.enEmptyChatMessage,
      session_enMainLabel: data.enMainLabel,
      session_student_language: data.student_language,
    };

    // Store all data in localStorage
    Object.entries(sessionData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        localStorage.setItem(key, value);
      }
    });
  };

  if (localStorage.getItem("session_user_status") === "Active") {
    navigate("/Home/dashboard");
  }

  return (
    <>
      <section className="login_section">
        <div className="container">
          <div className="login_row row align-items-center">
            <div className="login_img_column">
              <div className="login_img">
                <img className="img img-fluid" src={loginBg} alt="mainImg" />
              </div>
            </div>
            <div className="login_content_column">
              <div className="signInHeading">
                <h1>Salsa World Standard Class</h1>
              </div>
              <form className="login_form" onSubmit={loginFunction}>
                <div className="custom-select">
                  <button
                    className={`btn dropdown-toggle ${userToogle && "show"}`}
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => {
                      setUserToogle(!userToogle);
                    }}
                  >
                    {userValue === null ? "Select User" : userValue}
                  </button>
                  <ul className={`dropdown-menu ${userToogle && "show"}`}>
                    <li
                      onClick={() => {
                        setUserType("student_login");
                        setUserValue("STUDENT");
                      }}
                    >
                      <Link
                        className="dropdown-item"
                        onClick={() => {
                          setUserToogle(false);
                        }}
                      >
                        STUDENT
                      </Link>
                    </li>
                    <li
                      onClick={() => {
                        setUserType("teacher_login");
                        setUserValue("TEACHER");
                      }}
                    >
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={() => {
                          setUserToogle(false);
                        }}
                      >
                        TEACHER
                      </Link>
                    </li>
                  </ul>
                </div>
                <input
                  type="text"
                  className="login_input"
                  value={email || ""}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                />
                <input
                  type="password"
                  className="login_input"
                  value={password || ""}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                />
                <div className="login_btn">
                  <button
                    className={`btn btn_primary ${
                      isLoading ? "btn--loading" : ""
                    }`}
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Login"}
                  </button>
                </div>
              </form>
              <div className="changeSchool">
                <div className="schoolChangeLink">
                  <Link to="/forgot">Forgot Password</Link>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="copyright">
        <p>© 2023 SALSA WORLD STANDARD CLASS</p>
      </section>
    </>
  );
};

export default SignIn;
